import { queryClient } from "@/queryClient"

export type CreateUserQuery = {
  firstName: string
  lastName: string
  email: string
  role: string | null
}

export type CreateUserResponse = {
  firstName: string
  lastName: string
  email: string
  role: string
}

export const createUser = async (
  params: CreateUserQuery
) => {
  const { body } = await api.post<CreateUserResponse>(
    "/users/new/",
    { body: params }
  )

  queryClient.invalidateQueries({
    queryKey: [USERS_QUERY_KEY],
  })

  // As list_roles.user_count may have changed
  queryClient.invalidateQueries({
    queryKey: [ROLES_QUERY_KEY],
  })
  return body
}
